export default __webpack_public_path__ + "static/bg-doctor-3a1132e6fa0392eee7729f16de670cc0.jpg";